// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2h-zC","footer":"Form_footer__3fsHy"};